import { Chip, Grid, Tooltip, IconButton, Typography, Popover } from "@mui/material";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { FilterFieldInterface } from "components/DataGrid/DataGridProps";
import { EnumStatus } from "enum/enum";
import React, { useEffect, useState } from "react";
import { FnAxios, FnDialog } from "utilities/utilities";
import PushPinIcon from '@mui/icons-material/PushPin';
import { BtnAddOnTable, BtnEditOnTable, BtnPreviewOnTable, BtnViewImageOnTable, BtnViewOnTable } from "components/Button/ButtonTable";
import { useLocation, useNavigate } from "react-router";
import FilePopup from 'components/Input/UploadFile/components/PopUp/FilePopup';
import ChangeOrder from "components/System/ChangeOrder";
import InfoIcon from '@mui/icons-material/Info';
import { GetMenuPermission } from "utilities/SystemFunction";

const GallerySettingList = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const location = useLocation();
    const [loadingTable, setLoadingTable] = useState(false);
    const [arrGallery, setArrGallery] = useState([]);
    const [arrUserName, setArrUserName] = useState([]);
    const [fileImage, setFileImage] = useState();
    const [IsopenPopUp, setIsopenPopUp] = useState<any>(false);
    const [lstOrder, setLstOrder] = useState<any>([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [sUpdateName, setUpdateName] = useState(null);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "nOrder",
        sSortDirection: "asc"
    });
    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const getFormInitial = () => {
        AxiosFn.Get(`GallerySetting/GetFormInitial`, {}, (result) => {
            setArrGallery(result.objResult?.lstGalleryName);
            setArrUserName(result.objResult?.lstCreateName);
        });
    }

    const getTable = (p: PaginationInterface) => {
        setLoadingTable(true);
        let param = {
            ...p
        }
        AxiosFn.Post(`GallerySetting/GetTableSetting`, param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: result.lstGalleryTable ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

            let arrOpt = [];
            for (let i = 1; i <= result.nOrder; i++) {
                arrOpt.push({ label: `${i}`, value: `${i}` });
            }
            setLstOrder([...arrOpt]);
            window.scrollTo(0, 0);
        });
    };

    const onChangeOrder = async (sID, nOrder) => {
        let param = {
            sID: sID,
            NewOrder: nOrder,
            Table: "TbGallery",
            Column: "nGalleryID",
            TypeColumn: "",
            TypeID: 0,
            sLocation: location.pathname,
        };
        AxiosFn.Post("GallerySetting/OnChangeOrderGallery", param, (res) => {
            getTable(dataRow);
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        });
    };

    const handleDelete = (e) => {
        let param = {
            lstID: e,
            nType: 1
        }

        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`GallerySetting/RemoveDataTableGallery`, param, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTable(dataRow);
                    });
                }
            });
        });
    }

    const handleChangePin = (sID, isPin) => {
        // nMode: 1 = change pin, 2 = save
        setLoadingTable(true);

        let param = {
            sID: sID,
            isPin: isPin,
            nMode: 1
        }

        AxiosFn.Post(`GallerySetting/OnSubmitGallery`, param, (result) => {
            setLoadingTable(false);
            if (result.nStatusCode === 200) {
                getTable(dataRow);
            } else {
                DialogFn.Warning("ไม่สามารถปักหมุดได้เกิน 4 อัลบั้ม");
            }
        }, (err) => {
            DialogFn.Warning(err.Message);
        });
    }

    const OpenPopUp = (item) => {
        setFileImage(item.GalleryFile[0]);
        setIsopenPopUp(true);
    };

    const ClosePopUp = () => {
        setIsopenPopUp(false);
    };

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }

    const onGotoPage = (sID: string) => {
        window.open(`${process.env.REACT_APP_URL}/GalleryDetail?sID=${encodeURI(sID)}`, "_blank", "noreferrer");
    };

    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <BtnAddOnTable
                    IsDisabled={!isPermission}
                    id={"addGallery"}
                    onClick={() => navigate("/GallerySettingForm")}
                    txt={"Add"}
                />
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            headerName: 'ดำเนินการ',
            headerAlign: 'center',
            type: "actions",
            resizable: false,
            minWidth: 120,
            sortable: false,
            align: "center",
            flex: 1,
            getActions: (item) => {
                return [
                    <>
                        {item.row.GalleryFile && (
                            <BtnViewImageOnTable
                                txt="ดูรูป"
                                onClick={() => {
                                    OpenPopUp(item.row);
                                }}
                                id={'btnviewtb'}
                            />
                        )}
                        <BtnPreviewOnTable
                            key={item.row.sID}
                            id={"previewGallery"}
                            txt={"ดูตัวอย่าง"}
                            onClick={() => onGotoPage(item.row.sID)}
                        />
                        {isPermission ? (
                            <BtnEditOnTable
                                key={item.row.sID}
                                id={"editGallery"}
                                onClick={() => { navigate(`/GallerySettingForm?Gallery=${(item.row.sEncryptID)}`) }}
                            />
                        ) : (
                            <BtnViewOnTable
                                key={item.row.sID}
                                id="btnView"
                                onClick={() => { navigate(`/GallerySettingForm?Gallery=${(item.row.sEncryptID)}`) }}
                            />
                        )}
                    </>
                ];
            },
        },
        {
            field: 'nOrder',
            headerName: 'จัดเรียง',
            headerAlign: 'center',
            minWidth: 120,
            sortable: false,
            align: "center",
            flex: 1,
            renderCell: (item) => {
                return (
                    <ChangeOrder
                        disabled={!isPermission}
                        item={item}
                        value={item.row.nNo}
                        onChangeOrder={onChangeOrder}
                        // optOrder={lstDataOrder}
                        optOrder={lstOrder}
                    // disabled={!isPermission}
                    />
                )
            }
        },
        {
            field: 'isPin',
            headerName: 'ปักหมุด',
            headerAlign: 'center',
            align: 'center',
            minWidth: 70,
            editable: true,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        {item.row.isPin ?
                            <IconButton size="small"
                                disabled={!isPermission}
                                onClick={(e) => { handleChangePin(item.row.sID, item.row.isPin); }}
                            >
                                <PushPinIcon
                                    style={{ color: "#d9392e", cursor: "pointer" }}
                                />
                            </IconButton>
                            :
                            <IconButton size="small"
                                disabled={!isPermission}
                                onClick={(e) => { handleChangePin(item.row.sID, item.row.isPin); }}
                            >
                                <PushPinIcon

                                    style={{ color: "#b2b2b2", cursor: "pointer" }}
                                />
                            </IconButton>
                        }
                    </>
                );
            }
        },
        {
            field: 'sGalleryName',
            headerName: 'ชื่ออัลบั้ม',
            headerAlign: 'center',
            align: 'left',
            minWidth: 350,
            editable: true,
            flex: 1,
            renderCell: (item) => {
                return (
                    <Tooltip title={item.row.sGalleryName}>
                        <Grid sx={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden"
                        }}>
                            {item.row.sGalleryName}
                        </Grid>
                    </Tooltip>
                );
            }
        },
        {
            field: 'sCreateDate',
            headerName: 'วันที่สร้าง',
            headerAlign: 'center',
            align: 'center',
            minWidth: 120,
            editable: true,
            flex: 1
        },
        {
            field: 'sCreaterName',
            headerName: 'ชื่อผู้สร้าง',
            headerAlign: 'center',
            align: 'left',
            minWidth: 280,
            editable: true,
            flex: 1
        },
        {
            field: 'sUpdateDate',
            headerName: 'แก้ไขล่าสุด',
            headerAlign: 'center',
            align: 'center',
            minWidth: 130,
            editable: true,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdateDate}
                        </Grid>
                        <IconButton size="small"
                            disabled={!isPermission}
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: 'isActive',
            headerName: 'สถานะ',
            headerAlign: 'center',
            align: 'center',
            minWidth: 150,
            editable: true,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.isActive &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.isActive &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },
    ];

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่ออัลบั้ม", sFieldName: "sGalleryName", nGridLG: 5.5, nGridMD: 5.5, nGridSM: 5.5, nGridXS: 12 },
        { sTypeFilterMode: "multiselect", sLabel: "ชื่อผู้สร้าง", sFieldName: "lstUserName", optionSelect: arrUserName, nGridLG: 5.5, nGridMD: 5.5, nGridSM: 5.5, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "หมุด", sFieldName: "sPin",
            optionSelect: [
                {

                    label: "ปักหมุด",
                    value: "1"
                },
                {

                    label: "ไม่ปักหมุด",
                    value: "0"
                },

            ],
            nGridLG: 3, nGridMD: 3, nGridSM: 3, nGridXS: 12
        },
        { sTypeFilterMode: "date", sLabel: "วันที่สร้าง (เริ่ม)", sFieldName: "nDateStart", nGridLG: 2.5, nGridMD: 2.5, nGridSM: 2.5, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่สร้าง (สิ้นสุด)", sFieldName: "nDateEnd", nGridLG: 2.5, nGridMD: 2.5, nGridSM: 2.5, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 3, nGridMD: 3, nGridSM: 3, nGridXS: 12
        },
    ];

    useEffect(() => {
        getFormInitial();
        getTable(dataRow);
    }, []);

    return (
        <>
            {IsopenPopUp && (
                <FilePopup
                    file={fileImage}
                    isGallery={false}
                    IsopenPopUp={IsopenPopUp}
                    ClosePopUp={ClosePopUp}
                />
            )}
            <Grid item xs={12} sx={{ mt: "2%" }}>
                <DataGrid
                    sTableID='tableGalleryList'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isShowCheckBox={isPermission}
                    filterField={filter}
                    onDelete={handleDelete}
                />
            </Grid>

            {/* pop over */}
            <Popover
                id={`sUpdateNameGallery`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </>
    );
}

export default GallerySettingList;